import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { trust } from '@finn-no/trust-web-sdk-finn';

import { focusElementByRef, scrollToElementByRef } from '@/lib/helpers/scroll';
import { ErrorBoundary } from 'shared/util/ErrorBoundary';

const {
    publicRuntimeConfig: {
        trustUrl: { feedbackApiUrl },
    },
} = getConfig();

// TODO: Merge with ObjectRating..
export const RatingDesktop = ({ adId, isMobile, ratingRef }) => {
    const [trustFailed, setTrustFailed] = useState(false);

    const reputationWidget = useRef(null);

    const onClick = () => {
        scrollToElementByRef(ratingRef);
        focusElementByRef(ratingRef);
    };

    useEffect(() => {
        const settings = {
            itemSDRN: `sdrn:finn:classified:${adId}`,
            apiUrl: feedbackApiUrl,
            locale: 'nb-NO',
            onError: (e) => {
                // eslint-disable-next-line no-console
                console.error(`Problems with showing ratings for ${adId}`, e);
                setTrustFailed(true);
            },
        };

        if (reputationWidget.current) {
            trust.itemReputation.run(reputationWidget.current, settings);
        }
    }, [trustFailed, adId]);

    return !isMobile ? (
        <ErrorBoundary>
            <div className="objectRatingWidgetDesktop">
                {trustFailed ? (
                    <div>Vi klarte ikke å hente vurderinger nå, prøv igjen senere</div>
                ) : (
                    <>
                        <div className="mb-8" ref={reputationWidget} data-trust-item-reputation-widget="placeholder" />
                        <button className="button button--link" onClick={onClick}>
                            Se alle vurderinger
                        </button>
                    </>
                )}
            </div>
        </ErrorBoundary>
    ) : null;
};

RatingDesktop.propTypes = {
    adId: PropTypes.number.isRequired,
    isMobile: PropTypes.bool,
    ratingRef: PropTypes.shape({ current: PropTypes.any }),
};
